var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"title__14 weight__500 grey__151 lh__20"},[_vm._v("Single Answer Dropdown")]),_c('Input',{attrs:{"params":{label: 'Question', target: 'currentQuestItem.QuestItem.Name', textarea: 'true'}}}),_c('PseudoCheckRadio',{staticClass:"mt__40",attrs:{"params":{options: _vm.alternatives, type: 'radio', addOption: true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }